import firebase from './firebaseConfig';

// Pre-flight storage-quota check. The backend's `reserveBytes` (in
// getGranteePutAudioURL) is the real gate; this just lets the client warn
// before uploading. The owner can read their own /users/{uid}/metadata and
// /plans is world-readable, so no Cloud Function is needed.

// Reads the signed-in user's plan capacity and current usage. Returns null
// when there's no signed-in user. `remaining` mirrors the backend formula:
// bytesInPlan - bytes stored, floored at 0.
export async function getStorageQuota() {
    const uid = firebase.auth().currentUser?.uid;
    if (!uid) return null;
    const db = firebase.database();
    const metaSnap = await db.ref('users').child(uid).child('metadata').once('value');
    const meta = metaSnap.val() || {};
    const bytesStored = meta['bytes stored'] || 0;
    const planId = meta['plan'] || 'demodeckplan0';
    const planSnap = await db.ref('plans').child(planId).once('value');
    const bytesInPlan = (planSnap.val() || {}).bytesInPlan || 0;
    return { bytesStored, bytesInPlan, remaining: Math.max(0, bytesInPlan - bytesStored) };
}

// Greedy fit: walks files in order, accepting each that still fits the
// remaining space. A file that doesn't fit is rejected, but a later, smaller
// file can still slip in — this mirrors the backend's per-file reservation.
export function partitionFilesByQuota(files, remaining) {
    let used = 0;
    const accepted = [];
    const rejected = [];
    for (const file of files) {
        if (used + file.size <= remaining) {
            used += file.size;
            accepted.push(file);
        } else {
            rejected.push(file);
        }
    }
    return { accepted, rejected };
}
